(function () {
  const KEY = 'most_viewed_products';
  const MAX = 10;

  if (!location.pathname.includes('/products/')) return;

  const handle = location.pathname.split('/products/')[1]?.split('?')[0];
  if (!handle) return;

  let data = JSON.parse(localStorage.getItem(KEY)) || {};
  data[handle] = (data[handle] || 0) + 1;

  const sorted = Object.entries(data)
    .sort((a, b) => b[1] - a[1])
    .slice(0, MAX);

  localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(sorted)));
})();
